// @flow
import React from 'react';
import { ListItem } from 'material-ui/List';
import ActionInfo from 'material-ui/svg-icons/action/info';
import Avatar from 'material-ui/Avatar';
import GradeIcon from 'material-ui/svg-icons/action/grade';

import Duration from '../../../components/Duration';
import DateTime from '../../../components/DateTime';

type Props = {
  node: any,
};

const JobRequest = ({ node }: Props) => {
  const { sessions, grade, subject } = node;
  return (
    <ListItem
      key={node.id}
      leftAvatar={<Avatar icon={<GradeIcon />} />}
      rightIcon={<ActionInfo />}
      primaryText={`${subject.name} (${grade.name})`}
      secondaryText={sessions.map(({ timeSlots }) =>
        timeSlots.map((slot, index) => (
          <span key={slot.id}>
            <Duration {...slot.duration} /> <DateTime value={slot.startDate} />
            {index === timeSlots.length - 1 ? null : ', '}
          </span>
        ))
      )}
    />
  );
};

export default JobRequest;



// WEBPACK FOOTER //
// ./src/modules/admin/student/components/StudentJobRequest.js